import Vue from 'vue';
import { Tooltip } from 'element-ui';

Vue.directive('can-show', {
  inserted(el, binding, vnode) {
    // Split the string into section and action based on the colon
    const [section, action] = binding.value.split(':');
    // @ts-ignore
    const hasPermission = vnode.context.$store.getters.hasPermission(`${section}:${action}`);
    if (!hasPermission) {
      // Hide the element from the DOM if the user does not have the required permission
      el.style.display = 'none';
    }
  },
});

Vue.directive('can-enable', {
  // @ts-ignore
  bind(el, binding, vnode) {
    // Split the string into section and action
    const [section, action] = binding.value.split(':');
    // @ts-ignore
    const hasPermission = vnode.context.$store.getters.hasPermission(`${section}:${action}`);

    if (!hasPermission) {
      // Disable the element
      // @ts-ignore
      el.disabled = true;
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.6';
    }
  },
});

Vue.directive('can-alt-text', {
  inserted(el, binding, vnode) {
    const [section, action, text] = binding.value.split(':');
    // @ts-ignore
    const hasPermission = vnode.context.$store.getters.hasPermission(`${section}:${action}`);
    if (!hasPermission) {
      // Look for a child element with the data-can-alt-text-target attribute
      const target = el.querySelector('[data-can-alt-text-target="true"]');
      if (target) {
        // Replace the target element's inner text
        // @ts-ignore
        target.innerText = text || 'Permission Denied';
      } else {
        // Fallback: Replace the element's inner text
        el.innerText = text || 'Permission Denied';
      }
    }
  },
});
